<div
  class="main-container"
  theming
  [themingGroup]="LimitedTimeEventType[event.type]"
  themingAsset="background"
  [themingOverride]="event?.assets">
  <div class="event-container">
    <div class="header-container">
      @if (showCloseButton) {
        <slotcom-navigation-button
          type="close"
          rightPosition="0"
          (click)="closeModal()">
        </slotcom-navigation-button>
      }
      @if (showInfoButton) {
        <slotcom-navigation-button
          type="info"
          leftPosition="0"
          (click)="openInfo()">
        </slotcom-navigation-button>
      }
    </div>
    <div class="body-container">
      <div class="left-section">
        <ng-content select="[left-container]"></ng-content>
      </div>
      <div class="right-section">
        <ng-content select="[right-container]"></ng-content>
      </div>
    </div>
  </div>
</div>
